import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  currentStep = 1;
  showComprobante = false;
  allDocumentsSigned = false;
  aceptacionFinal = false;

  goToPreviousStep() {
    if (this.currentStep > 1) this.currentStep--;
  }

  goToNextStep() {
    if (this.currentStep < 6) this.currentStep++;
  }
} 